if (!customElements.get('hh-promo-bar')) {
  class HHPromoBar extends HTMLElement {
    connectedCallback() {
      if (this.interval) return;
      this.formatter = new Intl.DateTimeFormat('en-US',{timeZone:this.dataset.timeZone,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
      this.tick();
      this.interval = setInterval(() => this.tick(),1000);
      this.resize = new ResizeObserver(() => document.documentElement.style.setProperty('--hh-promo-height',this.getBoundingClientRect().height + 'px'));
      this.resize.observe(this);
    }
    parts(date) {
      return Object.fromEntries(this.formatter.formatToParts(date).filter(part => part.type !== 'literal').map(part => [part.type,Number(part.value)]));
    }
    nextMidnight(now) {
      const local = this.parts(new Date(now));
      const target = Date.UTC(local.year,local.month - 1,local.day + 1);
      let result = target;
      for (let attempt = 0; attempt < 3; attempt++) {
        const found = this.parts(new Date(result));
        const difference = target - Date.UTC(found.year,found.month - 1,found.day,found.hour,found.minute,found.second);
        result += difference;
        if (!difference) break;
      }
      return result;
    }
    tick() {
      const now = Date.now();
      if (!this.deadline || now >= this.deadline) this.deadline = this.nextMidnight(now);
      const seconds = Math.max(0,Math.floor((this.deadline - now) / 1000));
      const values = {days:Math.floor(seconds / 86400),hours:Math.floor(seconds % 86400 / 3600),minutes:Math.floor(seconds % 3600 / 60),seconds:seconds % 60};
      Object.entries(values).forEach(([name,value]) => { this.querySelector('[data-hh-' + name + ']').textContent = String(value).padStart(2,'0'); });
    }
    disconnectedCallback() { clearInterval(this.interval); this.interval = null; this.resize?.disconnect(); }
  }
  customElements.define('hh-promo-bar',HHPromoBar);
}
document.addEventListener('click',event => {
  const link = event.target.closest('a[href]');
  if (!link) return;
  const url = new URL(link.href,window.location.href);
  const target = document.getElementById('hh-contact');
  if (url.origin !== window.location.origin || url.hash !== '#hh-contact' || !target) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const drawer = document.querySelector('header-drawer>details[open]');
  const closeButton = drawer?.querySelector('.menu-drawer__close-menu-btn');
  if (closeButton) closeButton.click();
  history.pushState(null,'','#hh-contact');
  setTimeout(() => target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'}),drawer ? 450 : 0);
},true);
window.addEventListener('load',() => {
  if (window.location.hash === '#hh-contact') document.getElementById('hh-contact')?.scrollIntoView({block:'start'});
});

if (!customElements.get('hh-offer-ticker')) {
  class HHOfferTicker extends HTMLElement {
    connectedCallback() {
      this.group = this.querySelector('.hh-promo-messages');
      this.repeat = this.querySelector('.hh-promo-messages[aria-hidden]');
      if (!this.group || !this.repeat) return;
      this.original = [...this.group.children].map(item => item.cloneNode(true));
      this.resize = new ResizeObserver(() => this.fill());
      this.resize.observe(this);
      document.fonts.ready.then(() => { if (this.isConnected) this.fill(); });
      this.fill();
    }
    fill() {
      const width = this.clientWidth;
      if (!width) return;
      this.group.replaceChildren(...this.original.map(item => item.cloneNode(true)));
      const patternWidth = this.group.getBoundingClientRect().width;
      if (!patternWidth) return;
      const copies = Math.ceil(width / patternWidth) + 1;
      for (let i = 1; i < copies; i++) {
        this.group.append(...this.original.map(item => { const copy = item.cloneNode(true); copy.setAttribute('aria-hidden','true'); return copy; }));
      }
      this.repeat.replaceChildren(...[...this.group.children].map(item => item.cloneNode(true)));
      this.style.setProperty('--hh-ticker-duration',this.group.getBoundingClientRect().width / 120 + 's');
    }
    disconnectedCallback() { this.resize?.disconnect(); }
  }
  customElements.define('hh-offer-ticker',HHOfferTicker);
}


